import{__assign as r}from"../../../node_modules/tslib/tslib.es6.js";import{j as e}from"../../../node_modules/react/jsx-runtime.js";import{Grid as i}from"@mui/material";var o=function(o){return e.jsx(i,r({},o,{children:o.children}))};export{o as default};
//# sourceMappingURL=index.js.map
